module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-report-2.5544c907.svg";